import { forwardRef } from "react"

import Input from "./Input"
import {
  isObjectWithProperty,
  isANumber,
  isNotANumber,
} from "web/services/helpers"

import { formatValue } from "web/services/format"
import { sigDigits } from "web/components/Form/helpers"

const PercentageInput = forwardRef((props, ref) => {
  const { value, format, onChange, ...restOfProps } = props

  let transformedValue = value

  if (isObjectWithProperty(value, "value") && isANumber(value.value)) {
    const percentValue = (Number.parseFloat(value.value) * 100).toFixed(
      sigDigits(value.value, -2)
    )
    transformedValue = { ...value, value: percentValue }
  }

  function handleChange(value) {
    if (value === null || isNotANumber(value.value)) {
      onChange(value)
      return
    }

    const rawValue = (value.value / 100).toFixed(sigDigits(value.value, 2))
    onChange({ ...value, value: rawValue })
  }

  return (
    <Input
      ref={ref}
      value={transformedValue}
      format={format}
      formattedValue={formatValue({ ...value, format })}
      onChange={handleChange}
      {...restOfProps}
    />
  )
})

export default PercentageInput
